export class FileUpload  {

  file!: File;
  description!: string;
  updateByRole!: string;
  userId!: string;

  constructor(data: { file: File; description: string; updateByRole: string; userId: string; }) {
    this.file = data.file;
    this.description = data.description;
    this.updateByRole = data.updateByRole;
    this.userId = data.userId;
  }

  toFormData(): FormData {
    const formData = new FormData();

    formData.append('file', this.file);
    formData.append('Description', this.description);
    formData.append('UpdateByRole', this.updateByRole);
    formData.append('UserId', this.userId);

    return formData;
  }

}

// Get All Documents — request payload
export class GetAllDocumentsRequest {

  pias_rep_code!: string;

  constructor(data: { pias_rep_code: string }) {
    this.pias_rep_code = data.pias_rep_code;
  }

  toJson(): { pias_rep_code: string } {
    return {
      pias_rep_code: this.pias_rep_code
    };
  }
}

// Additional Documents — request payload
export class AdditionalDocumentsRequest {

  pias_rep_code!: string;
  updated_by_role!: string[];

  constructor(data: { pias_rep_code: string; updated_by_role?: string[] }) {
    this.pias_rep_code = data.pias_rep_code;
    this.updated_by_role = data.updated_by_role ?? ['NEWREP', 'DSU'];
  }

  toJson(): { pias_rep_code: string; updated_by_role: string[] } {
    return {
      pias_rep_code: this.pias_rep_code,
      updated_by_role: this.updated_by_role
    };
  }
}

// Get All Documents — one document item in responsedata
export class AllDocumentItem {

  onboardingDocumentType!: string;
  fileName!: string;
  id!: number;
  updatedByRole!: string;
  onboardingId?: number;
  docTypeId?: number;
  docName?: string; 

  constructor(data: {
    onboardingDocumentType: string;
    fileName: string;
    id: number;
    updatedByRole: string;
  }) {
    this.onboardingDocumentType = data.onboardingDocumentType;
    this.fileName = data.fileName;
    this.id = data.id;
    this.updatedByRole = data.updatedByRole;
  }
}

// Get All Documents — full API response
export class GetAllDocumentsResponse {

  message!: string;
  accesstoken!: string;
  responsedata!: AllDocumentItem[];

  constructor(data: {
    message: string;
    accesstoken: string;
    responsedata: AllDocumentItem[];
  }) {
    this.message = data.message;
    this.accesstoken = data.accesstoken;
    this.responsedata = (data.responsedata || []).map(
      (item) => new AllDocumentItem(item)
    );
  }
}

// Delete Document — request payload
export class DeleteDocumentRequest {

  id!: number;
  fileName!: string;
  userId!: string;
  

  constructor(data: { id: number; fileName: string; userId: string }) {
    this.id = data.id;
    this.fileName = data.fileName;
    this.userId = data.userId;
  }

  toJson(): { id: number; fileName: string; userId: string } {
    return {
      id: this.id,
      fileName: this.fileName,
      userId: this.userId
    };
  }
}